import type { ContactFormPayload } from "@upsquad/shared";
import { httpClient } from "./http.service";

export type ContactSubmitResult = { ok: true } | { ok: false; rateLimited?: boolean };

export const submitContactForm = async (payload: ContactFormPayload): Promise<ContactSubmitResult> => {
	const { error } = await httpClient.landing.contact.post(payload);

	if (error) {
		const status = error.status;
		return { ok: false, rateLimited: status === 429 };
	}

	return { ok: true };
};
